// Renders a server-error state with an optional Retry button.
// Drop into any screen where a useApi consumer might land in
// `status === 'error'`.

import type { ApiClientError } from '../../lib/api';
import { apiErrorMessage } from '../../lib/apiErrors';
import { Card } from './Card';
import { Button } from './Button';

interface ApiErrorCardProps {
  error: ApiClientError | Error;
  onRetry?: () => void;
  compact?: boolean;
}

export function ApiErrorCard({ error, onRetry, compact }: ApiErrorCardProps) {
  const message = apiErrorMessage(error);
  return (
    <Card
      variant="inset"
      role="alert"
      style={
        compact
          ? { paddingBlock: 'var(--space-3)' }
          : undefined
      }
    >
      <p style={{ marginBlockEnd: onRetry ? 'var(--space-3)' : 0 }}>{message}</p>
      {onRetry ? (
        <Button variant="secondary" size="md" onClick={onRetry}>
          Try again
        </Button>
      ) : null}
    </Card>
  );
}
